import { Pipe, PipeTransform } from '@angular/core';
import { ActionExecutionState, WorkOrderStatus } from '../../model/index';


@Pipe({ name: 'actionExecutionState' })
export class ActionExecutionStatePipe implements PipeTransform {

    transform(value: ActionExecutionState, workOrderStatus?: string): any {
        if (!value) {
            return '';
        }
        const label = value == ActionExecutionState.DONE_WITH_ISSUE ? 'DONE' : value;
        const icon = value != ActionExecutionState.DISCARDED ?
            `<span class="material-symbols-outlined sm-status-badge-icon">${value == ActionExecutionState.DONE ? 'check_circle' : 'emergency_home'}</span>` : '';
        const style = this.getStyle(value, workOrderStatus == WorkOrderStatus.EXECUTION);
        return `<div class="sm-status-badge" style="${style}">
                    ${label} ${icon}
                </div>`;
    }

    private getStyle(value: ActionExecutionState, temporary: boolean): string {
        let style = '';
        switch (value) {
            case ActionExecutionState.DONE:
                style = "color: #07570E;";
                if (temporary) {
                    style += "border: 1px dashed #07570E;";
                } else {
                    style += "background-color: #0EAE1C26;";
                }
                break;
            case ActionExecutionState.DONE_WITH_ISSUE:
                style = "color: #7B3E00;";
                if (temporary) {
                    style += "border: 1px dashed #7B3E00;";
                } else {
                    style += "background-color: #F57B0026;";
                }
                break;
            case ActionExecutionState.DISCARDED:
                style = "color: #7C0505;";
                if (temporary) {
                    style += "border: 1px dashed #7C0505;";
                } else {
                    style += "background-color: #F80A0A26;";
                }
                break;
            default:
                break;
        }
        return style;
    }
}